<template>
  <div>
    <slot />
    <Transition :name="animationName">
        <media-background :key="imgUri" :img-uri="imgUri" :lazy="loading === 'lazy'" />
    </Transition>
  </div>
</template>
<script setup lang="ts">
const { imgUri, fadeSlow = false, loading = 'lazy' } = defineProps<{
    imgUri: string,
    fadeSlow?: boolean,
    loading?: string,
}>();

const animationName = fadeSlow ? 'fade-slow' : 'fade';
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s .1s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-slow-enter-active,
.fade-slow-leave-active {
  transition: opacity 1s linear;
}

.fade-slow-enter-from,
.fade-slow-leave-to {
  opacity: 0;
}
</style>